import { Accordion } from "../global";
import { initSection } from "../utils";
import {
  buildFeaturedBlogSection,
  rebuyUpsellSmartCartSlider,
  buildFlavorsSlider,
  buildFullWidthImageText,
  buildOtherSodaComparison,
  buildOurStory,
  buildPublicationSlider,
  buildSlider,
  initSliceAnimation,
  buildRebuyRecommendations,
} from "../sections";

document.addEventListener("DOMContentLoaded", (_event) => {
  if (document.body.dataset.template === "index") {
    buildFullWidthImageText();
    buildOtherSodaComparison();
    buildOurStory();
    buildPublicationSlider();
    buildSlider();
  }
  buildFeaturedBlogSection();
  rebuyUpsellSmartCartSlider();
  buildFlavorsSlider();
  initSection("accordion-group", Accordion);
  initSliceAnimation();
  buildRebuyRecommendations();
});
